<div class="container">
    <div class="columns">
      <div class="column is-full">
        <div class="photoModule">
          <app-photo></app-photo>
        </div>
      </div>
    </div>
    <div class="infoSection">
      <app-section></app-section>
    </div>
</div>

